import React, { useState, useEffect, useRef, useCallback } from 'react';
import { formatId, formatYear } from '../../../utils';
import { Answer } from '../../../models';

import { Input } from 'antd';

import { formActions } from '../../../actions';
import { connect } from 'react-redux';

const Details = ({
  id,
  detail_text,
  detail,
  required,
  answer,
  financialYear,
  saveAnswer,
}) => {
  const detailsColumnLength = 3000;
  const textAreaRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState(null);

  const handleDetail = useCallback(
    e => {
      var optionId = e.target.getAttribute('data-for');
      // Sorry about this, this is horrendous but fixes the fact that we don't have controlled inputs
      // Store cursor position before updating
      setCursorPosition(e.target.selectionStart);
      saveAnswer(Answer(optionId, true, e.target.value));
    },
    [saveAnswer]
  );

  // Sorry about this, this is horrendous but fixes the fact that we don't have controlled inputs
  // Restore cursor position after value changes
  useEffect(() => {
    if (!cursorPosition) {
      return;
    }

    const textarea = textAreaRef.current?.resizableTextArea?.textArea;

    if (textarea) {
      textarea.setSelectionRange(cursorPosition, cursorPosition);
      setCursorPosition(null);
    }
  }, [answer.detail, cursorPosition]);

  const { TextArea } = Input;
  return (
    <span className="detail-box">
      <label htmlFor={formatId(id) + '-detail'}>
        {detail_text ? formatYear(detail_text, financialYear) : 'Justifier : '}
      </label>
      <TextArea
        ref={textAreaRef}
        name={formatId(id) + '-detail'}
        id={formatId(id) + '-detail'}
        data-for={detail}
        onChange={e => handleDetail(e)}
        required={required}
        value={answer.detail}
        autoSize={{ minRows: 3, maxRows: 20 }}
        maxLength={detailsColumnLength}
      />
      {answer.detail?.length > 0 && (
        <small className="char-count">
          Caractères restants :{' '}
          {detailsColumnLength - (answer.detail || 0).length} /{' '}
          {detailsColumnLength}
        </small>
      )}
    </span>
  );
};

const mapStateToProps = (state, props) => {
  return {
    financialYear: state.form.base.financialYear,
    answer: state.form.answers[props.detail] || {},
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveAnswer: answer => dispatch(formActions.saveAnswer(answer)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Details);
